import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function SpinnerButton({
    variant = 'primary',
    className = '',
    onClick,
    disabled = false,
    isLoading = false,
    label,
    type = 'button',
    ...rest
}) {
    const { t } = useTranslation();

    return (
        <Button
            variant={variant}
            className={`btn-large${className ? ` ${className}` : '' }`}
            onClick={onClick}
            disabled={disabled || isLoading}
            type={type}
            {...rest}
        >
            {isLoading ? (
                <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">{t('app.loading')}</span>
                </Spinner>
            ) : (
                label
            )}
        </Button>
    );
}

export default SpinnerButton;
